import React from 'react';
import 'partial/OfferManager/modules/CreditRepairExpert/CreditRepairExpertView.scss';
import SectionContainer from 'components/Containers/SectionContainer';
import { PageContainer } from 'components/Containers/PageContainer/PageContainer';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import ScorePotentialGuage from 'components/ScorePotentialGuage/ScorePotentialGuage';
import { Tabs } from 'antd';
import { Row } from 'components/Containers/Row/Row';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import Label from 'components/form/Label/Label';
import TextFromConfig from 'components/TextFromConfig';
import { hasHashParam } from 'helpers/domHelper';
import { getNegativeRemarksCount } from 'helpers/credit_info';
import { CREDIT_REPAIR_VERTICAL } from 'types/mrph.vertical.constants';

const { TabPane } = Tabs;

const CreditRepairExpertView = props => {
  const { firstMonthScoreChange, sixthMonthScoreChange, seenPixel } = props;
  const creditScore = props.creditInfo.creditScore;
  const negativeMarks = getNegativeRemarksCount(props.creditInfo);
  const defaultTestId = 'CreditRepairExpertView';
  const defaultTab = hasHashParam('sesamePotential') ? '6 months' : '1 month';

  const showSimulationTab =
    firstMonthScoreChange >= 0 && sixthMonthScoreChange >= 0;

  return (
    <PageContainer className="CreditRepairExpertView">
      {seenPixel}
      <SectionContainer>
        <Row type="action" className="cr-headerSimulationSection">
          <div className="cr-header-container">
            <TitleContainer className="creditRepairTitle">
              <Label
                type="H3"
                typeHeader={'h3'}
                datatestid={`${defaultTestId}-title`}
              >
                <TextFromConfig
                  path={TextFromConfig.paths.CREDIT_REPAIR_EXPERT_HEADER}
                />
              </Label>
            </TitleContainer>
            <Label
              type="Body-1 m-text-14"
              datatestid={`${defaultTestId}-subHeader`}
            >
              <TextFromConfig
                path={TextFromConfig.paths.CREDIT_REPAIR_EXPERT_PREPARAGRAPH}
              />
              {negativeMarks ? negativeMarks : ''}
              <TextFromConfig
                path={TextFromConfig.paths.CREDIT_REPAIR_EXPERT_POSTPARAGRAPH}
              />
            </Label>
          </div>
          {showSimulationTab && (
            <div
              className="SimulationGraphSection"
              data-testid={`${defaultTestId}-simSection`}
            >
              <div className="gauge-container padT0 padB16 padLR16">
                <Tabs
                  datatestid={`${defaultTestId}-tabs`}
                  defaultActiveKey={defaultTab}
                  onTabClick={props.tabClickEventHandler}
                  tabBarStyle={{}}
                >
                  <TabPane
                    datatestid={`${defaultTestId}-titleMonth1`}
                    tab={
                      <TextFromConfig
                        path={TextFromConfig.paths.CREDIT_REPAIR_EXPERT_MONTH1}
                      />
                    }
                    key="1 month"
                  >
                    <div className="cr-tabContent-container">
                      <ScorePotentialGuage
                        creditScore={creditScore}
                        scoreChange={firstMonthScoreChange}
                        size="small"
                        type="CreditRepair_oneMonth"
                        data={negativeMarks}
                        datatestid={`${defaultTestId}-month1`}
                        pagePosition="Credit Repair Expert"
                        vertical={CREDIT_REPAIR_VERTICAL}
                      />
                    </div>
                  </TabPane>
                  <TabPane
                    datatestid={`${defaultTestId}-titleMonth6`}
                    tab={
                      <TextFromConfig
                        path={TextFromConfig.paths.CREDIT_REPAIR_EXPERT_MONTH6}
                      />
                    }
                    key="6 months"
                  >
                    <div className="cr-tabContent-container">
                      <ScorePotentialGuage
                        creditScore={creditScore}
                        scoreChange={sixthMonthScoreChange}
                        size="small"
                        type="CreditRepair_sixMonth"
                        datatestid={`${defaultTestId}-month6`}
                        pagePosition="Credit Repair Expert"
                        vertical={CREDIT_REPAIR_VERTICAL}
                      />
                    </div>
                  </TabPane>
                </Tabs>
              </div>
            </div>
          )}
        </Row>

        <Row datatestid={`${defaultTestId}-offers`}>
          <StaticOfferContainer
            modulePosition={props.modulePosition}
            eventHandler={props.eventHandler}
            module={props.module}
            pagePosition={props.pagePosition}
            offerMetadataList={props.offer}
            extraAttributes={props.simulationAttributes}
          />
        </Row>
      </SectionContainer>
    </PageContainer>
  );
};

export default CreditRepairExpertView;
